import type { QueryClient } from 'react-query';

import QUERY_KEYS from 'config/api/QUERY_KEYS';

export const invalidateOwnerAssetRopaQueries = (queryClient: QueryClient, organizationId?: number) =>
  Promise.all([
    queryClient.invalidateQueries([QUERY_KEYS.ASSET_ROPA_MINE, organizationId]),
    queryClient.invalidateQueries([QUERY_KEYS.ASSET_ROPA_MINE_DETAIL, organizationId]),
    queryClient.invalidateQueries([QUERY_KEYS.ASSET_ROPA_MINE_METRICS, organizationId]),
    queryClient.invalidateQueries([QUERY_KEYS.DPIA_DETAIL, organizationId]),
    queryClient.invalidateQueries([QUERY_KEYS.DPIA_REVIEW_DETAIL, organizationId]),
    queryClient.invalidateQueries([QUERY_KEYS.DPIA_HISTORY, organizationId]),
  ]);

export default invalidateOwnerAssetRopaQueries;
